module.exports = __webpack_public_path__ + "static/media/question_bubble.d115a6a8.ico";